import DetailDeleteButton from './DetailDeleteButton';

export default DetailDeleteButton;
